<template>
	<v-row>
		<v-col>
			<v-data-table :items="data" :headers="headers" hide-default-footer class="elevation-1">
				<template v-slot:top>
					<v-toolbar flat>
						<v-toolbar-title>{{ $t('search') }}</v-toolbar-title>
						<v-divider class="mx-4" inset vertical></v-divider>
						<v-text-field v-model="reqData.text" autofocus prepend-icon="mdi-magnify" hide-details single-line clearable></v-text-field>
					</v-toolbar>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-icon small class="mr-2" @click="edit(item)">
						mdi-pencil
					</v-icon>
				</template>
				<template v-slot:no-data>
					<v-btn icon fab large @click="dialog = true">
						<v-icon>mdi-account-plus</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</v-col>
		<create-update-user-dialog v-if="dialog" @close="close()" :user="selected" @user="updateData($event)" />
	</v-row>
</template>

<script>
import _ from '~/plugins/lodash'
export default {
	data() {
		return {
			reqData: { text: '' },
			loading: false,
			dialog: false,
			selected: null,
			data: [],
			headers: [
				{ text: 'name', value: 'name' },
				{ text: 'email', value: 'email' },
				{ text: 'phone', value: 'phone' },
				{ text: 'type', value: 'type' },
				{ text: 'state', value: 'state' },
				{ text: 'actions', value: 'actions' }
			]
		}
	},

	watch: {
		'reqData.text': _.debounce(function() {
			if (this.reqData.text) {
				this.getUsers()
			}
		}, 300)
	},

	methods: {
		async getUsers() {
			this.loading = true
			let { data } = await this.$http.post('user/find', this.reqData)
			this.data = data
			this.loading = false
		},
		close() {
			this.dialog = false
			this.selected = null
		},
		edit(item) {
			this.selected = item
			this.dialog = true
		},
		updateData(user) {
			this._.forEach(this.data, (itm, key) => {
				if (itm.id === user.id) {
					Object.assign(this.data[key], user)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped></style>
